var l = (o, r, e = 1) => {
  if (!Number.isInteger(o)) throw new TypeError("start should be an integer");
  if (!Number.isInteger(r)) throw new TypeError("end should be an integer");
  if (!Number.isInteger(e)) throw new TypeError("step should be an integer");
  if (r < o) throw new RangeError("end should be greater than start");
  if (e < 1) throw new RangeError("step should be a positive integer");
  return Array.from({
    length: (r - o) / e + 1
  }, (i, n) => o + n * e);
};

var p = (o, r, e = 2, i = 2, n = "\u2026") => {
  let f = 1 + i * 2 + e * 2 + 2,
      c = Math.min(o, r),
      h = [];
  if (r <= f) h = l(1, r);else {
    let w = e > 0 ? 1 : c,
        t = {
      leftEdge: null,
      glueLeftCenter: null,
      centerPiece: null,
      glueCenterRight: null,
      rightEdge: null
    };
    c < f / 2 ? (t.leftEdge = l(1, Math.ceil(f / 2) + i), t.centerPiece = [n], e > 0 && (t.rightEdge = l(r - (e - 1), r))) : c > r - f / 2 ? (e > 0 && (t.leftEdge = l(w, e)), t.centerPiece = [n], t.rightEdge = l(Math.min(r - Math.floor(f / 2) - i, c - i), r)) : (t.centerPiece = l(c - i, c + i), e > 0 && (t.leftEdge = l(w, e)), e > 0 && (t.rightEdge = l(r - (e - 1), r)), t.glueLeftCenter = t.centerPiece[0] == e + 2 ? [e + 1] : [n], t.glueCenterRight = [n]), h = Object.values(t).filter(b => b !== null).flat();
  }
  return h;
},
    y = (o = {}) => {
  let {
    curPage: r = 1,
    numPages: e = 1,
    numPagesAtEdges: i = 2,
    numPagesAroundCurrent: n = 2,
    glue: f = "\u2026"
  } = o;
  return p(r, e, i, n, f);
};

export { p as generate, y as generateFromObj };